import styled from "styled-components"

import type { TUpload, TErrorText } from '../types'

import dlIcon from '../../assets/download-icon.svg'
import errIcon from '../../assets/error-icon.svg'

const Wrapper = styled.div`
    width: 560px;
    padding: 32px 24px;
    margin-top: 44px;

    display: flex;
    flex-direction: column;
    align-items: center;

    background: #FFFFFF;
    /**box-shadow: 0px 12px 20px rgba(0, 108, 130, 0.4);*/
    box-shadow: 0px 4px 12px #006c8281;
    border-radius: 12px;

    @media screen and (max-width: 640px) {
        width: 460px;
    }

    @media screen and (max-width: 480px) {
        width: 100%;
        padding: 40px 16px;
    }
`

const Icon = styled.img`
    width: 44px;
    height: 52px;
    margin-bottom: 40px;

    @media screen and (max-width: 480px) {
        width: 44px;
        height: 52px;
        margin-bottom: px;
    }
`

const Title = styled.div`
    margin-bottom: 22px;

    text-align: center;
    color: #202020;
    font-style: normal;
    font-weight: bold;
    font-size: 32px;
    line-height: 38px;

    @media screen and (max-width: 480px) {
        margin-bottom: 19px;

        font-size: 24px;
        line-height: 32px;
    }
`

const Description = styled.div`
    margin-bottom: 24px;

    text-align: center;
    color: #606060;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;

    @media screen and (max-width: 480px) {
        font-size: 14px;
        line-height: 20px;
    }
`

const Button = styled.button`
    width: 160px;
    padding: 16px 0;

    background: #FC531B;
    border: 1px solid #c4390b;
    border-radius: 8px;

    color: #FFFFFF;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 24px;
    text-align: center;

    text-decoration: none;
    cursor: pointer;
    user-select: none;
    transition: background .3s;

    &:hover {
        background: #FF6D3D;
    }

    &:focus {
        box-shadow: 0 0 0 4px hsla(20, 100%, 47%, 0.40);
    }

    &:active {
        background: #EA4C18;
        border: 1px solid #c4390b;
    }

    @media screen and (max-width: 480px) {
        width: 100%;
    }
`

const ErrorWrapper = styled.div`
    width: 100%;
    padding: 16px;
    margin-bottom: 24px;

    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;

    background: rgba(254, 212, 209, 0.3);
    border-radius: 8px;
`

const ErrorIcon = styled.img`
    width: 40px;
    height: 48px;
    margin-right: 12px;

    @media screen and (max-width: 480px) {
        width: 26px;
        height: 32px;
    }
`

const ErrorBody = styled.div`
    color: #606060;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
`

const ErrorTitle = styled.div`
    font-weight: bold;
    font-size: 16px;
    line-height: 32px;
` 

export const throwErrorScreen = (upload: TUpload, reason?: string) => {
    const setErrorText = upload.setErrorText
    const setScreen = upload.setScreen

    switch (reason) {
        case 'sanety':
        case 'upload':
        case 'task':
        case 'check':
        case 'catch':
        default:
            setErrorText({
                icon: dlIcon,
                title: 'Server not responded',
                description: 'Oops! Something went wrong. Unfortunately, an error has occurred.',
                subTitle: 'Details',
                subDescription: 'Check your network connection and try again',
            })
            break;
    }

    return setScreen('error')
}

const Error = ({
    text,
}: {
    text: TErrorText,
}) => {
    return (
        <Wrapper>
            {
                text.icon &&
                <Icon src={text.icon} />
            
            }

            {
                text.title &&
                <Title>{text.title}</Title>
            }

            {
                text.description &&
                <Description>{text.description}</Description>
            }

            {
                (text.subTitle || text.subDescription) &&
                <ErrorWrapper>
                    <ErrorIcon src={errIcon} alt="Error Icon" />
                    <ErrorBody>
                        {
                            text.subTitle && 
                            <ErrorTitle>{text.subTitle}</ErrorTitle>
                        }

                        {
                            text.subDescription &&
                            <div>{text.subDescription}</div>
                        }
                    </ErrorBody>
                </ErrorWrapper>
            }

            <Button onClick={
                () => location.reload()
            }>Reload page</Button>
        </Wrapper>
    )

}

export default Error